module.exports = __webpack_public_path__ + "static/media/psgkit.70b6cc37.png";